export default __webpack_public_path__ + "static/media/replyicon.356e14b4.png";